import { map } from 'ramda'

export const image = map(imageObject => ({
  '@type': 'ImageObject',
  url: imageObject.uri,
  height: imageObject.height,
  width: imageObject.width
}))
